import timer from './timer.webp';
import sunRays from './sun-rays.webp';
import prizeGlow from './prize-glow.webp';
import quickRuleArrowLeft from './quick-rule-arrow-left.webp';
import quickRuleArrowRight from './quick-rule-arrow-right.webp';
import awardBackgroundMobile from './award-background-mobile.webp';
import awardBackgroundDesktop from './award-background-desktop.webp';

export default {
  timer,
  sunRays,
  prizeGlow,
  quickRuleArrowLeft,
  quickRuleArrowRight,
  awardBackgroundMobile,
  awardBackgroundDesktop,
};
